import * as Popover from '@radix-ui/react-popover';
import { BoltToken } from '~/components/ui/icons/BoltToken';
import type { Pricing } from '~/utils/pricing';

export const PlanBlock = ({ pricing }: { pricing?: Pricing }) => {
  if (!pricing) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 items-start h-full">
      <div className="max-w-[428px] pr-0 sm:pr-8 text-bolt-ds-textPrimary flex-1 overflow-y-auto flex flex-col gap-3 rounded-xl">
        <div className="text-xl font-semibold">Selected plan</div>

        <div className="font-semibold text-4xl">{pricing.plan === 'pro' ? 'Pro' : 'Teams'}</div>
        <div className="flex gap-2 items-center">
          <BoltToken className="size-8" />
          <div className="text-lg">{pricing.tokens} per month</div>
        </div>
        {pricing.features && (
          <>
            <div className="mt-5">You get:</div>
            <div className="flex flex-col gap-2 mb-4 text-bolt-ds-textSecondary">
              {pricing.features.map((feature) => (
                <div key={typeof feature === 'string' ? feature : feature.text} className="flex items-start gap-2">
                  <div className="size-5 shrink-0 mt-0.5 i-heroicons:check-solid" />
                  <span className="mt-1 flex items-center gap-1">
                    <span>{typeof feature === 'string' ? feature : feature.text}</span>
                    {typeof feature !== 'string' && (
                      <Popover.Root>
                        <Popover.Trigger asChild>
                          <span className="cursor-pointer size-4 inline-flex shrink-0 i-heroicons:question-mark-circle text-sm text-bolt-ds-iconSecondary" />
                        </Popover.Trigger>

                        <Popover.Portal>
                          <Popover.Content
                            side="bottom"
                            sideOffset={6}
                            align="center"
                            className="max-w-100 text-xs text-bolt-ds-textSecondary px-3 py-2 bg-bolt-ds-surfaceOne z-max rounded-md border border-bolt-ds-borderOutline"
                          >
                            {feature.tooltip}
                          </Popover.Content>
                        </Popover.Portal>
                      </Popover.Root>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
